import React, {useContext, useRef, useState} from 'react';
import PropTypes from 'prop-types'
import styles from './ComponentPrimaryDomainResult.scss';
import Checkbox from "../../common/primitives/CheckBox";
import Label from "../../common/primitives/Label";
import {_truncateDomainName} from "../../common/helpers/HelperFunc";
import Button, {buttons} from "../../common/primitives/Button";
import {ContextServicePrice} from "../../context/ContextServicePriceProvider";
import SelectPrice from "../../common/primitives/SelectPrice";

import redXImg from './img/red-x-sm.png';
import SearchDomainInput from "../../common/primitives/SearchDomainInput";
import {ContextCart} from "../../context/ContextCartProvider";
import Submit from "../../common/primitives/Submit";
import YellowErrorBlock from "../../common/primitives/YellowErrorBlock";
import helpers from "../../common/scss/helpers/_helpers.scss";
import LoadingRow from "../../common/primitives/LoadingRow";
import {ContextTLD} from "../../context/ContextTLDProvider";
import HelperGoogleAnalytics4 from '../../common/helpers/HelperGoogleAnalytics4';
import {__t} from '../../common/lang/text-resource';

const ComponentPrimaryDomainResult = React.memo(
  /**
   *
   * @param {{
   *     domainData: DomainData
   * }}props
   * @returns {*}
   */
  (props) => {
	  const {
		  domainData,
		  searchedWithTLD,
		  hideButtons,
		  hideMessage,
		  continueAction,
		  submitSearchAnother,
		  messages,
		  eventRaise
	  } = props;

	  const checkboxRef = useRef(null);
	  const searchInputRef = useRef(null);

	  let {
		  id,
		  is_free,
		  domain_full,
		  domain_tld,
		  is_cyrillic,
		  isPremium,
		  domain_name,
		  showBGDomainSavedMessage,
		  showBGDomainNotAllowedMessage,
		  bg_domain_similar,
		  is_checked
	  } = domainData;

	  // форматираме името на домейна така, че да се вижда тлд-то.
	  const domain_full_formatted = _truncateDomainName(domain_full, domain_tld, 24);

	  /** @type ContextServicePriceProvider */
	  const servicePriceContext = useContext(ContextServicePrice);

	  const cTLD = useContext(ContextTLD);

	  /** @type ContextCartProvider */
	  const cartContext = useContext(ContextCart);

	  const priceData = servicePriceContext.getForId(id);
	  /**
	   *  Вземаме домейна от количката. Ако не е в количката идва празен масив.
	   */
	  const domainLineData = cartContext.getNewDomainInCart(domain_full);

	  /**
	   * Проверката за двойките домейни. Ако подобният домейн е в количката показваме съобщени.
	   */
	  if (bg_domain_similar !== '') {
		  const similarDomainLineData = cartContext.getNewDomainInCart(bg_domain_similar);
		  showBGDomainSavedMessage = domainLineData.length === 0 && similarDomainLineData.length === 1;
	  }


	  const inCart = domainLineData.length > 0;
	  const isPricePremium = priceData[Object.keys(priceData)[0]].isPremium;
	  let selectedPriceFromCart = priceData[Object.keys(priceData)[0]].id;

	  /**
	   * Ако домейна е в количката вземаме избрания период от там. Ако домейна е премиум, винаги избираме първият период.
	   */
	  if (inCart) {
		  selectedPriceFromCart = cartContext.getSelectedPriceForLineId(domainLineData[0].id);
		  if (selectedPriceFromCart === '') {
			  selectedPriceFromCart = priceData[Object.keys(priceData)[0]].id;
		  }
	  }

	  /**
	   * Използваме го за смяна на периода
	   */
	  const [selectedPrice, setSelectedPrice] = useState(selectedPriceFromCart);

	  /**
	   * Използваме го за да покажем блокчето за търсене на домейн
	   */
	  const [searchAnotherDomain, setSearchAnotherDomain] = useState(false);

	  /**
	   * Използваме го за да показваме грешките при търсене на домейн
	   */
	  const [domainNameError, setDomainNameError] = useState('');


	  /**
	   * Използваме го за да показваме анимация при повторно търсене
	   */
	  const [innerLoading, setInnerLoading] = useState(false);


	  /**
	   * При смяна на периода, ако домейна е вколичката, да се сменя периода и в количката.
	   * @param {PriceData} selected
	   */
	  const setPriceId = (selected) => {
		  setSelectedPrice(selected.id);
		  if (checkboxRef.current.state.checked) {
			  addRemoveDomainFromCart(true, selected.id);
		  }
	  };

	  /**
	   * Добавяне премахване на домейн в количката
	   * @param {boolean} checked Ако чекбокса е маркиран, добавяме услугата, иначе премахваме я.
	   * @param {string} servicePriceId С коя цена ще добавим услугата.
	   */
	  const addRemoveDomainFromCart = (checked, servicePriceId) => {

		  eventRaise('ToggleCartDisabledState', {disable: true});

		  if (checked) {

			  //Ако сменяме периода на основния домейн, да не проверяваме дали домейна е в количката.
			  if (typeof servicePriceId === 'string' && servicePriceId !== '') {
				  cartContext.addDomainToCart(domain_full, servicePriceId, () => {
					  eventRaise('ServiceAddedToCart', {reloadCart: false});
				  });
				  return;
			  }

			  // Проверяваме дали домейна е в количката. Ако е, не добавяме наново услугата
			  if (domainLineData.length === 0) {
				  cartContext.addDomainToCart(domain_full, selectedPrice, () => {
					  eventRaise('ServiceAddedToCart', {reloadCart: false});
				  });
			  } else {
				  eventRaise('ToggleCartDisabledState', {disable: false});
			  }
		  } else {
			  //Ако домейна е в количката, премахваме го.
			  if (domainLineData.length > 0) {
				  cartContext.removeFromCart(domainLineData[0].id);
			  } else {
				  eventRaise('ToggleCartDisabledState', {disable: false});
			  }
		  }
	  };

	  /**
	   * Търсене на нов домейн.
	   *
	   * @param {Event} e
	   */
	  const submitSearchForm = (e) => {
		  e.preventDefault();
		  setInnerLoading(true);

		  let domainName = searchInputRef.current.value.toLowerCase().trim();

		  domainName = domainName.replace(/^www\./, '');

		  domainName = domainName.toLowerCase().trim();
		  const arrDomainData = domainName.split('.');
		  const domainNameTMP = arrDomainData[0];
		  const domainTld = domainName.substring(domainNameTMP.length + 1, domainName.length)

		  if (domainTld === '') {
			  domainName = domainName + '.com';
		  }

		  //Валидации на домейна
		  if (domainName === '') {
			  setDomainNameError(messages.EMPTY_DOMAIN_NAME_ERROR);
			  searchInputRef.current.focus();
			  setInnerLoading(false);
			  return;
		  }
		  try {

			  // _validateDomainName(domainName, false);
			  cTLD.validateDomainName(domainName, false);

		  } catch (e) {
			  setDomainNameError(messages[e].replace('{%domainName%}', domainName));
			  searchInputRef.current.focus();
			  setInnerLoading(false);
			  return;
		  }


		  submitSearchAnother(domainName, () => {
			  setInnerLoading(false);
		  });
	  };

	  const clearDomainNameError = () => {
		  setDomainNameError('');
	  };

	  return (
		<div data-test={`domain-name-${domain_full}-id-${id}`}>
			{/* Грешки от валидации */}
			{
			  domainNameError !== '' && <YellowErrorBlock error={domainNameError}/>
			}

			{/*
				 	Ако домейна е свободен и е в количката, показваме съобщение на жълт фон.
				 	В зависимост от това дали домейна е търсен с tld или не се показват различни съобщения.
				 	Ако hideMessage е подадено true, не показваме съобщението.
				*/}
			{
			  is_free === 1 && inCart === true && hideMessage !== true && !searchAnotherDomain &&
			  <div className={styles.yellowBlock} data-layout="margin-bottom--smm"
				   data-test="domain-auto-add-message">
				  {
					  searchedWithTLD ?
						<div>
							{__t('домейнът-е-свободен-за-регистрация-и-е-добавен-в-ff2948')}
						</div>
						:
						<div>
							{__t('Домейнът')} .<span>COM</span> {__t('е свободен за регистрация и е добавен в поръчката!')}
						</div>
				  }

			  </div>
			}
			{/* Съобщение за зает домейн. */}
			{
			  is_free === 0 && hideMessage !== true && !searchAnotherDomain &&
			  <div className={styles.yellowBlock} data-layout="margin-bottom--smm"
				   data-test="domain-taken-message">
				  {__t('Домейнът е зает! Потърсете алтернатива!')}
			  </div>
			}

			<form
			  className={styles.container}
			  onSubmit={submitSearchForm}
			  data-test="search-domain-form"
			  data-layout={`row gutter-none start padding-left--15 padding-right--15 text-left ${!searchedWithTLD && 'margin-bottom--20'}`}>
				{/*
					 	Ако клиента не е натиснал на потърси друг домейн, показваме ред с името на домейна и чекбокс.
					 */}
				{
				  searchAnotherDomain === false &&
				  <div data-layout="col 12 6@sm">
					  <div data-layout="row gutter-none start">
						  <div data-layout="col 1">
							  {
								  is_free === 1 ?
									<Checkbox
									  ref={checkboxRef}
									  name={id + '_primary'}
									  checked={inCart}
									  customOnchange={addRemoveDomainFromCart}/> :
									<img src={redXImg} alt={__t("Зает")}
										 data-layout="padding-top--xs margin-left--xs"/>
							  }
						  </div>
						  <div data-layout="col 11 padding-left--smm padding-bottom--sm"
							   className={`${(is_free) ? styles.isFree : styles.isDisabled} ${styles.domainName}`}>
							  <Label
								htmlFor={is_free ? id + '_primary' : undefined}
								text={domain_full_formatted} title={domain_full}/>
							  {
								is_free === 0 &&
								<span className={styles.taken} data-test="domain-taken-label">{__t('зает')}</span>
							  }
						  </div>
					  </div>
				  </div>
				}
				{/*
					 	Ако клиента не е натиснал на потърси друг домейн, и домейна е свободен, показваме селектор за период
					 */}
				{
				  (is_free === 1 && !searchAnotherDomain) === true &&
				  <div data-layout="col 12 6@sm text-center padding-bottom--xs"
					   data-test="free-domain-price-selector">
					  <SelectPrice
						name="primary_domain_price_selector"
						id="primary_domain_price_selector"
						newPriceCol="priceNew"
						valueCol="id"
						labelCol="term"
						options={Object.values(priceData)}
						oldPriceCol={!isPremium && !isPricePremium ? 'basePriceNew' : ''}
						currencyCol="currency"
						selected={selectedPrice}
						onChange={setPriceId}/>
				  </div>
				}
				{/* Допълнително съощение за bg домейн */}
				{
					((domain_tld === 'bg' || domain_tld === 'бг') && is_free && !searchAnotherDomain) ?
					  <div data-layout="col 12 padding-bottom--sm">
						  <Button
							name={'bg_dom_info'}
							value={__t('Изисква заявка или пълномощно')}
							className={`${buttons.buttonLink} ${buttons.action} ${helpers.f10}`}
							onClick={() => eventRaise('ShowPopup', {popupName: 'bgDomainPopup'})}/>
					  </div> : ''

				}
				{/* Допълнително съощение за bg домейн */}
				{
					((showBGDomainSavedMessage && is_free) || (showBGDomainNotAllowedMessage && is_checked)) && !searchAnotherDomain ?
					  <div data-layout="col 12 padding-bottom--sm">
						  <Button
							value={showBGDomainNotAllowedMessage ? __t('Неразрешена регистрация') : __t('Домейнът се запазва за регистрация от вас')}
							className={`${buttons.buttonLink} ${buttons.action} ${helpers.f10}`}
							onClick={() => eventRaise('ShowPopup', {
								popupName: showBGDomainNotAllowedMessage ? 'bgDomainPopupNotAllowed' : 'bgDomainPopupSaved',
								replaceField: '%!domain_name!%',
								replaceValue: domain_full
							})}/>
					  </div>
					  : ''

				}

				{/* Допълнително съощение за premium домейн */}
				{
					(isPremium || isPricePremium) && is_free && !searchAnotherDomain ?
					  <div data-layout="col 12 padding-bottom--sm">
						  <Button
							name={'premium_dom_info'}
							value={__t('Регистрация на специални (premium) домейни')}
							className={`${buttons.buttonLink} ${buttons.action} ${helpers.f10}`}
							onClick={() => this.eventRaise('ShowPopup', {popupName: 'premiumDomainPopup'})}/>
					  </div>
					  : ''

				}

				{/* Поле за търсене на нов домейн */}
				{
				  (is_free === 1 && !searchAnotherDomain) === false &&
				  <div data-layout="col 12 padding-bottom--xs padding-top--sm margin-bottom--xs">
					  <SearchDomainInput
						defaultValue={domain_name}
						inputName={'domainName'}
						placeholder={__t('домейн име')}
						hasError={domainNameError !== ''}
						customRef={searchInputRef}
						onChange={clearDomainNameError}/>
				  </div>
				}

				{/* Бутони за продължи с поръчката и търсене на нов домейн */}
				{
					hideButtons !== true ?
					  is_free === 1 && !searchAnotherDomain ?
						<div data-layout="col 12 text-center" data-test="continue-button-container">
							<Button onClick={() => {
								HelperGoogleAnalytics4.TrackContinueButton('Variant_domain_free')
								continueAction();
							}
							} value={__t("Продължи с поръчката")}
									id={"page_domain_result_continue_01"}/>
						</div>
						:
						<div
						  data-layout={`col 12 text-center ${searchAnotherDomain === true && 'padding-bottom--smm'}`}>
							{
								innerLoading ? <LoadingRow/> : <Submit value={__t("Провери дали е свободен")}/>
							}
						</div>
					  : ''
				}
				{/* Бутон за активиране на режим търси друг домейн. */}
				{
					hideButtons !== true && !searchAnotherDomain ?
					  is_free === 1 &&
					  <div data-layout="col 12 text-center margin-top--15"
						   data-test="search-another-button-container">
						  <Button
							className={`${buttons.buttonLink} ${buttons.action}`}
							onClick={() => setSearchAnotherDomain(true)}
							value={__t("Потърси друг домейн")}/>
					  </div>
					  : ''
				}
			</form>
		</div>
	  )
  }
);
ComponentPrimaryDomainResult.propTypes = {
	domainData: PropTypes.object.isRequired,
	searchedWithTLD: PropTypes.bool,
	hideButtons: PropTypes.bool,
	hideMessage: PropTypes.bool,
	messages: PropTypes.objectOf(PropTypes.string),
};
export default ComponentPrimaryDomainResult;